var exports = {
  "p_": "x805b157e--cc7e75--list",
  "DD": "x805b157e--cc7e75--title",
  "kL": "x805b157e--cc7e75--container",
};

module.exports = exports;
